export default __webpack_public_path__ + "static/team-Toby-38c0e2cc6184379d57c7ffa30b7aecdd.png";